import { render, staticRenderFns } from "./ModalComparision.vue?vue&type=template&id=3ec852f4"
import script from "./ModalComparision.vue?vue&type=script&lang=js"
export * from "./ModalComparision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports